var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41249 9.81705V7.58597L4.18172 7.58597V6.41342H6.41249V4.18111H7.58504V6.41342H9.81767V7.58597H7.58504V9.81705H6.41249Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99957 0.777832C3.56313 0.777832 0.777344 3.56362 0.777344 7.00005C0.777344 10.4365 3.56313 13.2223 6.99957 13.2223C10.436 13.2223 13.2218 10.4365 13.2218 7.00005C13.2218 3.56362 10.436 0.777832 6.99957 0.777832ZM1.94989 7.00005C1.94989 4.2112 4.21071 1.95038 6.99957 1.95038C9.78842 1.95038 12.0492 4.2112 12.0492 7.00005C12.0492 9.78891 9.78842 12.0497 6.99957 12.0497C4.21071 12.0497 1.94989 9.78891 1.94989 7.00005Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutlined);
export default __webpack_public_path__ + "static/media/addCircleOutlined.493741b0e12bb07c6d5a36dc24289f2d.svg";
export { ForwardRef as ReactComponent };